import { Box } from "@chakra-ui/react";
import Footer from "./footer";
import Navbar from "./navbar";
import StudentNavbar from "../../student/Layout/navbar";

const PublicLayout = ({ children, color, bg, register = true }) => {
  return (
    <Box minH="100vh" h="100%" w="100%" className="public" overflowX="hidden">
      <Box h="7%">
        {!register ? (
          <StudentNavbar />
        ) : (
          <Navbar color={color} bg={bg} register={register} />
        )}
      </Box>
      {children}
      <Footer />
    </Box>
  );
};

export default PublicLayout;
